<template>
  <div class="app vh-100">
    <div class="container vh-100">
      <b-row class="justify-content-center align-items-center vh-100">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body v-if="showMessage">
                <b-form>
                  <label style="font-size: 22px; text-align: center">Registration successfully completed, thank you to make a first step to joining us.</label>
                  <p></p>
                </b-form>
                <span class="text-center">Go to<router-link class="btn btn-link" to="/login">Login</router-link></span>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountVerified',
  data () {
    return {
      showMessage: false
    }
  },
  created () {
    if (!this.$route.query.key) {
      this.$toastr.error('Activation key not found')
    } else {
      this.validateToken(this.$route.query.key)
    }
  },
  methods: {
    validateToken: function (token) {
      this.$loading.show(true)
      this.axios.post('/confirm-registration', {
        activation_key: token
      }).then(response => {
        if (response && response.status === 200) {
          this.showMessage = true
          this.$toastr.success(response.data.message)
          setTimeout(() => {
            this.$router.push('/login')
          }, 7000)
        } else {
          this.$toastr.error(response.data.message)
          this.$router.push('/login')
        }
        this.$loading.hide()
      }).catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.message) {
          this.$toastr.error(error.response.data.message)
        }
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style scoped>

</style>
